module.exports = __webpack_public_path__ + "static/media/html5-original-wordmark.eb0bfe64.svg";